import { Helmet } from "react-helmet-async";
import useSiteConfig from "@/lib/useSiteConfig";

/**
 * SiteHead — global, page-agnostic head injections that should appear on every
 * route. Today this only reflects the admin-managed favicon; other persistent
 * meta (default OG image, theme color) live in `public/index.html` because they
 * need to be in the HTML before React boots so social-share crawlers see them.
 *
 * Per-page <Helmet> tags inside individual pages override these site-wide ones
 * when present (e.g. a property page sets its hero photo as og:image).
 */
export default function SiteHead() {
  const cfg = useSiteConfig();
  if (!cfg.favicon_url) return null;
  return (
    <Helmet>
      <link rel="icon" href={cfg.favicon_url} data-testid="dynamic-favicon" />
      <link rel="apple-touch-icon" href={cfg.favicon_url} />
    </Helmet>
  );
}
